/**
 * Similar ao `next` do jQuery.
 * @see https://api.jquery.com/next/
 */
$.fn.next = function() {
  return $(this[0].nextSibling);
};
